import { render, staticRenderFns } from "./TermsOfUse.vue?vue&type=template&id=7c6f6f0b&scoped=true&"
var script = {}
import style0 from "./TermsOfUse.vue?vue&type=style&index=0&id=7c6f6f0b&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c6f6f0b",
  null
  
)

export default component.exports